import {Download01Icon} from '@/components/ui/icon/Icon'
import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {ExportSiarDialog} from '@/features/projects/components/export-siar-dialog/ExportSiarDialog'
import {useTranslation} from '@/translations/i18n'
import {ProjectIndex} from '@/features/projects/types'

export const ProjectOptionExportSiarMenuItem = ({project}: {project: ProjectIndex}) => {
    const {t} = useTranslation()

    return (
        <ExportSiarDialog
            projects={[project]}
            customTrigger={({onClick, isDisabled}) => (
                <MenuItem
                    onClick={e => {
                        e.preventDefault()
                        onClick(e)
                    }}
                    disabled={isDisabled}
                >
                    <Download01Icon />
                    {t('projects:export_siar')}
                </MenuItem>
            )}
        />
    )
}
